import React, { useState } from 'react';
import { getImages } from '../const';

const historicaloption = [
    { title: 'San Francisco Ferrari', text: "2023 Maserati Grecale GT AWD with Navigation / Leather / 360 Surround View Camera / Red Brake Calipers / Grecale Accessories / Valve Stem Caps / Microfibre Cloth / Hill Descent Control / Hill Start Assist / Full LED Headlamps / Full LED Taillamps / Rear View Backup Camera / 19” Wheels / AFR with Pedestrian Recognition / Front & Rear Parking Sensors w/ Rear Active Braking / Sonus Faber Premium Audio System / Maglia Milano Composite Trim / Power Adjustable Black Leather Steering Wheel / Heated, Power Folding Door Mirrors / Power Liftgate / Badging in Brushed Chrome / Chrome Window Surround / Chrome Finish Quad Exhaust" },
    { title: 'Long Island Maserati', text: "2024 Maserati Grecale GT AWD with Navigation / Leather / 360 Surround View Camera / Red Brake Calipers / Grecale Accessories / Valve Stem Caps / Microfibre Cloth / Hill Descent Control / Hill Start Assist / Full LED Headlamps / Full LED Taillamps / Rear View Backup Camera / 19” Wheels / AFR with Pedestrian Recognition / Front & Rear Parking Sensors w/ Rear Active Braking / Sonus Faber Premium Audio System / Maglia Milano Composite Trim / Power Adjustable Black Leather Steering Wheel / Heated, Power Folding Door Mirrors / Power Liftgate / Badging in Brushed Chrome / Chrome Window Surround / Chrome Finish Quad Exhaust" },
    { title: 'Premier Luxury Imports', text: "2025 Maserati Grecale GT AWD with Navigation / Leather / 360 Surround View Camera / Red Brake Calipers / Grecale Accessories / Valve Stem Caps / Microfibre Cloth / Hill Descent Control / Hill Start Assist / Full LED Headlamps / Full LED Taillamps / Rear View Backup Camera / 19” Wheels / AFR with Pedestrian Recognition / Front & Rear Parking Sensors w/ Rear Active Braking / Sonus Faber Premium Audio System / Maglia Milano Composite Trim / Power Adjustable Black Leather Steering Wheel / Heated, Power Folding Door Mirrors / Power Liftgate / Badging in Brushed Chrome / Chrome Window Surround / Chrome Finish Quad Exhaust" }
]

const HistoricalOptionsModal = ({ close }) => {
    const [copyText, setCopyText] = useState(Array(historicaloption.length).fill(false));

    const handleCopy = (index) => {
        const textarea = document.querySelectorAll('.ho-box textarea')[index];
        if (textarea) {
            navigator.clipboard.writeText(textarea.value).then(() => {
                const updatedCopyText = [...copyText];
                updatedCopyText[index] = true;
                setCopyText(updatedCopyText);
                setTimeout(() => {
                    updatedCopyText[index] = false;
                    setCopyText(updatedCopyText);
                }, 2000); // Reset text after 2 seconds
            }).catch(err => {
                console.error('Failed to copy text: ', err);
            });
        }
    };

    return (
        <>    
            <div className="modal-content p-0">
                <div className='d-none d-lg-block'>
                    <div className="modal-header p-3 chat-modal-header">
                        <h1 className="modal-title filter-modal-title text-center w-100 fw-500">
                            Historical Options
                        </h1>
                        <button className="sm-box-close mt-0" type="button" onClick={close}>
                            <img src={getImages('white-close.svg')} alt="Close" />
                        </button>
                    </div>
                </div>
                <div className="modal-body py-4">
                    <div className='sm-title fw-600 mb-4'>OPTIONS LISTED BY PREVIOUS DEALERS</div>
                    {historicaloption.map((dealer, index) => (
                        <div className='ho-box mb-4' key={index}>
                            <div className='d-flex align-items-center justify-content-between mb-3'>
                                <div>
                                    <div className='ho-xxs-title text-uppercase'>Dealership</div>
                                    <div className='sm-title'>{dealer.title}</div>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <button 
                                        type='button' 
                                        className='copy-btn text-uppercase me-3' 
                                        onClick={() => handleCopy(index)}
                                    >
                                        <span className='copy-icon'></span> {copyText[index] ? 'Copied' : 'Copy'}
                                    </button>                            
                                    <button type='button' className='red-btn text-uppercase fw-700 px-4'>Apply</button>                            
                                </div>
                            </div>
                            <div>
                                <textarea 
                                    className='form-control ho-form-control' 
                                    defaultValue={dealer.text}>
                                </textarea>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default HistoricalOptionsModal;

